import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IGetEnfoqueDiferencial } from '../shared/interfaces/configuracion';
import { API_URL } from 'lib-base';

@Injectable({
  providedIn: 'root'
})
export class EnfoqueDiferencialService {
  readonly baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private readonly http: HttpClient) {
    this.baseUrl = `${this.apiUrl}/api/enfoque-diferencial`;
  }

  getEnfoqueDiferencial(): Observable<IGetEnfoqueDiferencial[]> {
    return this.http.get<IGetEnfoqueDiferencial[]>(`${this.baseUrl}`);
  }
}
